import React from 'react';
import { DeveloperCredit } from './DeveloperCredit';

export const SupportFooter: React.FC = () => {
  return <DeveloperCredit />;
};


